// prop-types is a library for typechecking of props.
import { Box } from "@mui/material";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { themesSelector } from "theme/selector";
function DashboardLayout({ children }) {
  const { isMiniSidenav } = useSelector(themesSelector);
  return (
    <Box
      sx={({ breakpoints, transitions, functions: { pxToRem } }) => ({
        height: "100%",

        WebkitBoxOrient: "vertical",
        [breakpoints.up("xl")]: {
          marginLeft: isMiniSidenav ? pxToRem(100) : pxToRem(304),
          transition: transitions.create(["margin-left", "margin-right"], {
            easing: transitions.easing.sharp,
            duration: transitions.duration.enteringScreen,
          }),
        },
      })}
    >
      {children}
    </Box>
  );
}

// Typechecking props for the DashboardLayout
DashboardLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DashboardLayout;
